import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';

export function setNotificationsAsRead(unreadIds: number[]): Promise<void> {
  return api({
    url: ApiPath.NotificationsStatusRead,
    method: 'post',
    data: unreadIds,
  });
}
